import * as angular from "angular";
import { CampaignDataProvider } from "../../data-provider/campaign.dp";
import { Organisation } from "../../models/organisation.model";
import { OrganisationDataProvider } from "../../data-provider/organisation.dp";
import { WhiteLabelDataProvider } from "../../data-provider/white-label.dp";
import { PermissionCheck } from "../../shared/permission";

let OrganisationOverviewCardComponent = {
    selector: "vcOrganisationOverviewCard",
    templateUrl:
        "/angular/components/organisation/organisation-overview-card.component.html",
    bindings: {},
    controller: class OrganisationOverviewCardController {
        private activeOrganisation: Organisation;
        private __env: any;
        private $location: ng.ILocationService;

        public whiteLabelDataProvider: WhiteLabelDataProvider;
        public permissionProvider: PermissionCheck;
        public receptionEnabled: boolean = true;

        constructor(
            $location: ng.ILocationService,
            CampaignDataProvider: CampaignDataProvider,
            OrganisationDataProvider: OrganisationDataProvider,
            __env: any,
            WhiteLabelDataProvider: WhiteLabelDataProvider,
            PermissionCheck: PermissionCheck
        ) {
            this.$location = $location;
            this.__env = __env;
            this.whiteLabelDataProvider = WhiteLabelDataProvider;
            this.permissionProvider = PermissionCheck;

            PermissionCheck.getFeaturePermissions().then((features: any): void => {
                const reception = features?.RECEPTION;
                this.receptionEnabled = !!reception
                    && reception.attributes?.status !== "Hidden"
                    && (typeof reception.isEnabled === "function"
                        ? reception.isEnabled()
                        : true);
            });

            CampaignDataProvider.getOrganisations().then(
                (organisation: Organisation) => {
                    this.activeOrganisation = organisation;
                    OrganisationDataProvider.headlineStats(
                        organisation.oid
                    ).then((stats) => {
                        this.activeOrganisation.stats = stats;
                    });
                }
            );
        }

        editConversionRate(): void {
            this.$location.path("/leader_customize").search({ tab: "conversion" });
        }
    },
};

angular
    .module("organisation")
    .component(
        OrganisationOverviewCardComponent.selector,
        OrganisationOverviewCardComponent
    );
